<template>
    <b-modal ref="profile_modal" size="xl" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.doc.id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="p-2">
                <b-overlay :show="is_load" rounded="sm" >
                    <div class="location_data" v-if="!is_load">
                        <b-tabs content-class="mt-3" v-if="doc.id > 0">
                            <b-tab v-for="(tab,index) in draw_tabs" @click="set_active(index)" :title="get_tab_title(tab)" :key="index">
                                <template slot="title">
                                    <slot :doc="doc" :name="'title_' + tab.index" >
                                        {{get_tab_title(tab)}}
                                    </slot>
                                </template>
                                
                                
                                <slot :doc="doc" :name="tab.index" >
                                    <component @doc_change="change_param" v-bind:is="tab.index" :doc="doc"></component>
                                </slot>
                            
                            </b-tab>
                        </b-tabs>
                    </div>
                </b-overlay>
            </div>
        </div>
        
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed">
                    Закрити
                </button>
                
                <button type="button" v-on:click="save_location" class="btn btn-primary waves-effect waves-themed">
                    Зберегти
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>

import doc_general from "./tabs/doc_general.vue";
import doc_files  from "./tabs/doc_files.vue";

export default {
    name: "engineer_doc_edit",
    
    components : {
        doc_general,
        doc_files
    },
    
    created() {
        EventBus.$on("edit_engineer_doc", this.edit_doc);
        EventBus.$on('remove_engineer_doc',this.delete_doc)
    },
    
    data() {
        return {
            tabs : [
                {
                    index : "doc_general",
                    title : "Загальні",
                },
                
                {
                    index : "doc_files",
                    title : "Файли",
                },
            ],
            modal_position : "left",
            is_show_modal: false,
            is_load: false,
            
            doc: {
                id: 0,
            },
        }
    },
    
    methods : {
        
        close_modal() {
            this.close();
        },
        
        close() {
            this.doc = this.default_item;
            this.is_show_modal = false;
        },
        
        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },
        
        set_active (obj) {
            for (let tab in this.draw_tabs) {
                this.draw_tabs[tab].is_active = false;
            }
            this.draw_tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.draw_tabs[obj].index, user_id: this.user_id});
        },
        
        change_param(event) {
            if(event.hasOwnProperty("type")) {
                let type = event.type;
                if(this.doc.hasOwnProperty(type)) {
                    this.doc[type] = event.val;
                }
            }
        },
        
        edit_doc(doc_id) {
            this.load_item(doc_id);
        },
        
        delete_doc(id) {
            let self = this;
            confirm_imc('Видалити?').then(res => {
                self.remove_doc(id);
            });
        },
        
        async remove_doc(id) {
            console.log('remove_sb_doc',id);
            await api.delete('/enginer/doc/' + id).then(({data}) => {
                if (data.status === "operation_success") {
                    window.location.reload();
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
        
        
        async load_item(id) {
            this.is_load = true;
            this.doc = this.default_item;
            IMC_CORE.showloading();
            await api.get('/enginer/doc/' + id).then(({data}) => {
                this.is_show_modal = true;
                if (data.status === "operation_success") {
                    this.doc = data.data;
                }
            }).catch(err => {
                console.log(err);
                if (err.response && err.response.hasOwnProperty('data')) {
                    EventBus.$emit('show_toast', {
                        err: err.response.data.message,
                        type: "danger",
                        title: err.response.data.status
                    });
                } else {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                }
            })
                .finally(() => {
                    IMC_CORE.hideloading();
                    this.is_load = false;
                });
        },
        
        async save_location() {
            this.is_load = true;
            await api.patch('/enginer/doc/' + this.doc.id,this.doc).then(({data}) => {
                if (data.status === "operation_success") {
                    this.close();
                    IMC_CORE.snackbar('Збережено');
                    window.location.reload();
                }
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },
    computed: {
        
        draw_tabs() {
            return  JSON.parse(JSON.stringify(this.tabs));
        },
        
        default_item() {
            return {
                id: 0,
            }
        },
        
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-xl";
            }
            
            return "modal-dialog-right modal-xl";
        },
    }
}
</script>

<style scoped>

</style>
